export const BRAND_LOGO = require('../assets/brand_logo_transparent.png');
export const BRAND_LOGO_WITH_BG = require('../assets/brand_logo.png');
export const DASHBOARD_ICON = require('../assets/dashboard.png');
export const DEFAULT_ICON = require('../assets/default.png');
export const EXIT_ICON = require('../assets/exit.png');
export const FAVICON_ICON = require('../assets/favicon.png');
export const LOGOUT_ICON = require('../assets/logout.png');
export const MENU_ICON = require('../assets/menu.png');
export const PROFILE_ICON = require('../assets/profile.png');
export const RIGHT_ARROW_ICON = require('../assets/right_angle_bracket.png');
export const LEFT_ARROW_ICON = require('../assets/left_angle_bracket.png');
export const SETTINGS_ICON = require('../assets/settings.png');
export const CROSS_ICON = require('../assets/x.png');
export const BRAND_ICON = require('../assets/brand_icon_transparent.png');
export const NAME_ICON = require('../assets/name.png');
export const EMAIL_ICON = require('../assets/email.png');
export const USERNAME_ICON = require('../assets/username.png');
export const PWD_HIDDEN_ICON = require('../assets/pwd_hidden.png');
export const PWD_VISIBLE_ICON = require('../assets/pwd_visible.png');
export const PWD_ICON = require('../assets/password.png');
export const FAV_CONTENT_ICON = require('../assets/fav_content.png');
export const CHECKED_ICON = require('../assets/checked.png');
export const UNCHECKED_ICON = require('../assets/unchecked.png');
export const ANDROID_ICON = require('../assets/android.png');
export const IOS_ICON = require('../assets/ios.png');
export const HOME_ICON = require('../assets/home.png');
export const CONTACT_US_ICON = require('../assets/contact_us.png');
export const ABOUT_US_ICON = require('../assets/about_us.png');
export const LIKE_ICON = require('../assets/like.png');
export const DISLIKE_ICON = require('../assets/dislike.png');
export const LIKE_SOLID_ICON = require('../assets/solid_like.png');
export const DISLIKE_SOLID_ICON = require('../assets/solid_dislike.png');
export const BLOG_BG = require('../assets/blog_bg.png');
export const RIGHT_PLAY_ICON = require('../assets/right_play.png');
export const LEFT_PLAY_ICON = require('../assets/left_play.png');
export const DOWN_ARROW = require('../assets/down_arrow.png');
export const UP_ARROW = require('../assets/up_arrow.png');
